import { useContext, useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import CompanyContext from "../context/CompanyProvider";
import AdminHeader from "./AdminHeader";
import NotificationBell from "./NotificationBell";

const AppShell = ({ children }) => {
  const { company } = useContext(CompanyContext);
  const location = useLocation();
const navigate = useNavigate();
  const userRole = localStorage.getItem("role");

const [mobileOpen, setMobileOpen] = useState(false);

const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

useEffect(() => {
  const resize = () => setIsMobile(window.innerWidth < 1024);

  window.addEventListener("resize", resize);

  return () => window.removeEventListener("resize", resize);
}, []);

  // ✅ Sidebar only for Leads

const sidebarRoutes = [
  "/dashboard",
  "/leads",
  "/bookings",
  "/trips",
  "/quotation-builder",
  "/operations",
  "/transport",
  "/accounts",
  "/reports",
  "/hotels",
  "/users",
  "/teams",
  "/destinations",
  "/offers",
  "/admin",
  "/company-management",
  "/profile",
];

  const showSidebar = sidebarRoutes.some((route) =>
    location.pathname.startsWith(route),
  );

  // SuperAdmin bypass
  if (userRole === "superadmin") {
    return children;
  }

  const displayCompany = company || {
    name: "Travel CRM",
    logoUrl: "/logo-default.png",
    themeColor: "#1890ff",
  };

  // ✅ CLEAN MENU (NO OPERATIONS HERE)

const menuItems = [
  { path: "/dashboard", name: "Dashboard" },
  { path: "/leads", name: "Leads" },

...( ["admin", "accounts", "reservations"].includes(userRole)
    ? [{ path: "/bookings", name: "Bookings" }]
    : [] ),

  { path: "/quotation-builder", name: "Quotations" },
  { path: "/operations", name: "Operations" },
  { path: "/transport/inventory", name: "Transport" },
  { path: "/hotels", name: "Hotels" },

...( ["admin", "sales_manager", "team_lead"].includes(userRole)
    ? [{ path: "/reports", name: "Reports" }]
    : [] ),

  ...( ["admin", "accounts"].includes(userRole)
      ? [{ path: "/accounts", name: "Accounts" }]
      : [] ),

  { path: "/profile", name: "Profile" },
];

  return (

<div
  style={{
    display: "flex",
    minHeight: "100vh",
    width: "100%",
    maxWidth: "100vw",
    background: "#f8fafc",
    overflowX: "hidden",
    boxSizing: "border-box",
  }}
>

{isMobile && mobileOpen && (
  <div
    onClick={() => setMobileOpen(false)}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,.45)",
      zIndex: 999,
    }}
  />
)}

      {/* SIDEBAR */}
      {isMobile && showSidebar && (
<div
  style={{
    position: isMobile ? "fixed" : "relative",
    left: isMobile ? (mobileOpen ? 0 : -260) : 0,
    top: 0,
    bottom: 0,
    width: 260,
    height: "100dvh",
    borderRight: "1px solid #e5e7eb",
    padding: "1.2rem 0.75rem",
    background: "#ffffff",
    display: "flex",
    flexDirection: "column",

    overflow: "auto",
    WebkitOverflowScrolling: "touch",

    transition: "left .25s ease",

    zIndex: 1300,

    boxShadow: isMobile
      ? "0 10px 30px rgba(0,0,0,.18)"
      : "none",
  }}
>


  {isMobile && (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: 10,
      }}
    >
      <button
        onClick={() => setMobileOpen(false)}
        style={{
          border: "none",
          background: "transparent",
          cursor: "pointer",
        }}
      >
        <CloseOutlined />
      </button>
    </div>
  )}


          {/* COMPANY LOGO */}
          <div
            style={{
              marginBottom: "1.2rem",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src={displayCompany.logoUrl || "/logo-default.png"}
              alt="Company Logo"
              style={{
                width: 36,
                height: 36,
                objectFit: "contain",
              }}
              onError={(e) => {
                e.target.src = "/logo-default.png";
              }}
            />
          </div>

          {/* NAVIGATION */}
          <nav style={{ flex: 1 }}>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
              }}
            >
              {menuItems.map((item) => {
               const isActive =
                   location.pathname.startsWith(item.path);

                return (
                  <li key={item.path} style={{ marginBottom: 2 }}>
                    <Link
                      to={item.path}
onClick={() => {
    if (isMobile) {
      setMobileOpen(false);
    }
  }}

                      style={{
                        textDecoration: "none",
                        color: isActive ? "#111" : "#6b7280",
                        fontWeight: isActive ? 600 : 500,
                        display: "block",
                        padding: "6px 8px",
                        fontSize: 13,
                        borderRadius: 6,
                        background: isActive ? "#e5e7eb" : "transparent",
                        borderLeft: isActive
                          ? "3px solid #2563eb"
                          : "3px solid transparent",
                        paddingLeft: 6,
                      }}
                    >
                      {item.name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      )}

      {/* MAIN AREA */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          background: "#ffffff",
          width: "100%",
          maxWidth: "100%",
          overflowX: "hidden",
          boxSizing: "border-box",
        }}
      >
{/* HEADER */}

{isMobile ? (

  <div
    style={{
      height: 56,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 14px",
      background: "#fff",
      borderBottom: "1px solid #e5e7eb",
      position: "sticky",
      top: 0,
      zIndex: 1100,
    }}
  >

    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 14,
      }}
    >

      <button
        type="button"
        onClick={() => setMobileOpen((prev) => !prev)}
        style={{
          border: "none",
          background: "transparent",
          cursor: "pointer",
          padding: 0,
          fontSize: 22,
          display: "flex",
          alignItems: "center",
        }}
      >
        <MenuOutlined />
      </button>

      <div
        onClick={() => navigate("/dashboard")}
        style={{
          fontWeight: 700,
          fontSize: 18,
          cursor: "pointer",
        }}
      >
        TRAVNOK
      </div>

    </div>

    <NotificationBell />

  </div>

) : (

  <AdminHeader />

)}

        {/* CONTENT */}
        <div
          style={{
            flex: 1,
            padding: isMobile ? "12px 10px" : "24px",
            width: "100%",
            maxWidth: "100%",
            boxSizing: "border-box",
            overflowX: "hidden",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default AppShell;
